import { Stack, Typography } from '@ethings/ui-toolkit';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { useResponsiveText } from '../../../hooks';
import { innerText, testid } from '../../../util';

interface StakeholderCardBaseProps extends PropsWithChildren {
  action?: ReactNode;
  hideRole?: boolean;
  role: string;
}

export const StakeholderCardBase: FC<StakeholderCardBaseProps> = ({ action, children, hideRole, role }) => {
  const h6Styles = useResponsiveText('1.25rem', innerText(role).length, {
    minFontSize: '1rem',
    maxFontSize: '1.25rem',
    textLengthThreshold: 20,
  });

  return (
    <Stack spacing={1} data-testid={testid`stakeholder-${role}-section`} >
      <Stack
        display="flex" flexDirection="row" justifyContent="space-between"
      >
        {!hideRole && (
          <Typography
            data-testid={testid`stakeholder-title-${role}`}
            variant="h6"
            textTransform="capitalize"
            style={{
              fontSize: h6Styles.fontSize,
              lineHeight: h6Styles.lineHeight,
              wordBreak: h6Styles.wordBreak,
              whiteSpace: h6Styles.whiteSpace,
              overflow: h6Styles.overflow,
              textOverflow: h6Styles.textOverflow,
            }}
          >
            {role}
          </Typography>
        )}
        {action}
      </Stack>
      {children}
    </Stack>
  );
};
